import '../../libraries/login-success';
import '../../libraries/turnstile-container';
import { setzeTrackingTag } from '../../libraries/passwort-ampel';
import { fetchRetryTimeout } from '../../libraries/request-retry-timeout';
import { getABTestValue, setABTestValueDLTag } from '../../libraries/tracking';

class NutzerRegistrierung extends HTMLElement {
    connectedCallback() {
        this.init();

        this.setupValidation({
            inputId: 'email-input',
            containerClass: 'email-error-container',
            getTemplateId: this.getEmailErrorTemplateId.bind(this),
        });
        this.setupValidation({
            inputId: 'password-input',
            containerClass: 'password-error-container',
            getTemplateId: () => 'error-password-too-short',
        });
        this.triggerScreenReaderErrorMessage();

        this.addFormSubmitHandler();
        this.fehlerhafteFelder = [];

    }

    init() {
        this.addJsClass();
        this.addPasswortToggleHandler();
        // this.listenFormFields();
        this.addTurnstileSuccessListener();
        this.addTurnstileGate();
    }

    listenFormFields() {
        const fields = this.querySelectorAll('input');
        fields.forEach((field) => {
            field.addEventListener('invalid', () => {
                this.querySelector('input:invalid').scrollIntoView();
            });
        })
    }

    addJsClass() {
        this.querySelector('form').classList.add('js');
    }

    addPasswortToggleHandler() {
        const toggleButton = this.querySelector('[interaction=passwort-toggle]');
        const input = this.querySelector('.input-passwort');

        toggleButton.addEventListener('click', (event) => {
            event.preventDefault();

            const isVisible = input.getAttribute('type') === 'text';
            input.setAttribute('type', isVisible ? 'password' : 'text');

            toggleButton.setAttribute('aria-pressed', String(!isVisible));
            toggleButton.setAttribute('aria-label', isVisible ? 'Passwort anzeigen' : 'Passwort verbergen');

            toggleButton.classList.remove('button-eye-open', 'button-eye-closed');
            toggleButton.classList.add(isVisible ? 'button-eye-open' : 'button-eye-closed');
        });
    }

    triggerScreenReaderErrorMessage () {
        const emailErrorText = document.querySelector('[data-email-error-message]');
        const passwordErrorText = document.querySelector('[data-password-error-message]');

        const emailLiveRegion = document.getElementById('form-email-error');
        const passwordLiveRegion = document.getElementById('form-password-error');

        const updateLiveRegion = (region, message) => {
            if (region && message) {
                region.textContent = '';
                setTimeout(() => {
                    region.textContent = message.textContent;
                    region.focus();
                }, 30);
            }
        };

        updateLiveRegion(emailLiveRegion, emailErrorText);
        updateLiveRegion(passwordLiveRegion, passwordErrorText);
    }

    setupValidation({ inputId, containerClass, getTemplateId }) {
        const input = this.querySelector(`#${inputId}`);
        const errorContainer = this.querySelector(`.${containerClass}`);

        if (!input || !errorContainer || typeof getTemplateId !== 'function') return;

        let currentTemplateId = null;

        const showError = () => {
            if (!input.value.trim()) return;

            const templateId = getTemplateId(input);
            if (!templateId || templateId === currentTemplateId) return;

            const template = this.querySelector(`#${templateId}`);
            if (!template) return;

            const content = template.content.cloneNode(true);
            const errorTextId = `${templateId}-text`;

            errorContainer.replaceChildren(content);
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', errorTextId);
            currentTemplateId = templateId;
        };

        const clearError = () => {
            if (currentTemplateId !== null) {
                errorContainer.replaceChildren();
                input.setAttribute('aria-invalid', 'false');
                input.removeAttribute('aria-describedby');
                currentTemplateId = null;
            }
        };

        input.addEventListener('blur', () => {
            if (!input.value.trim()) {
                clearError();
            } else if (input.checkValidity()) {
                clearError();
            } else {
                showError();
            }
        });

        input.addEventListener('input', () => {
            clearError();
        });

        input.addEventListener('invalid', (e) => {
            e.preventDefault();
            showError();
        });
    }

    getEmailErrorTemplateId(input) {
        const emailAddress = input.value.trim();

        if (!emailAddress) return 'error-email-required';
        if (!emailAddress.includes('@')) return 'error-email-missing-at';

        const parts = emailAddress.split('@');
        if (parts.length !== 2) return 'error-email-invalid';

        const [local, domain] = parts;

        if (!local) return 'error-email-missing-local';
        if (!domain) return 'error-email-missing-domain';

        if (input.validity.typeMismatch) return 'error-email-invalid';

        return null;
    }

    addFormSubmitHandler() {
        this.addEventListener('submit', (event) => { this.submitForm(event); });
    }

    getCsrfToken(element) {
        return {
            csrfToken: element.getAttribute("csrf-token"),
            csrfHeaderName: element.getAttribute("csrf-header"),
            csrfCookieName: element.getAttribute("csrf-cookie")
        }
    }

    async submitForm(event) {
        setzeTrackingTag();
        const form = event.target;
        const formMethod = form.getAttribute('method').toLowerCase();
        if (formMethod === 'dialog') {
            return true;
        }
        this.allgemeinenFehlerAusblenden();
        event.preventDefault();
        this.disableButton();
        try {
            const httpMethod = form.getAttribute('method');
            const config = {
                method: httpMethod,
                redirect: 'error',
                body: new FormData(form)
            };
            let queryParams = new URLSearchParams(window.location.search);
            queryParams.append('headless', 'true');
            const formAction = form.getAttribute('action');
            const actionWithoutParameters = formAction.toString().split('?')[0];
            const url = actionWithoutParameters + '?' + queryParams.toString();
            const csrfToken = this.getCsrfToken(this);
            const response = await fetchRetryTimeout(url, config, csrfToken);
            if (!!response && response.ok) {
                const responseHtml = await response.text();
                this.render(responseHtml);
                this.checkForFehlermeldungenInResponse(this)
                this.init();
            } else {
                this.allgemeinenFehlerEinblenden();
            }
        } catch (e) {
            this.allgemeinenFehlerEinblenden();
        }
        this.enableButton();
    }

    checkForFehlermeldungenInResponse(containerElement) {
        try {
            this.fehlerhafteFelder = [];
            const fehlerKnoten = containerElement.querySelectorAll('[fehlerfeld]');
            fehlerKnoten.forEach((element) => {
                const fehlerfeld = element.getAttribute('fehlerfeld');
                this.fehlerhafteFelder.push(fehlerfeld);
            });
        } catch (e) {}
    }

    allgemeinenFehlerEinblenden() {
        try {
            this.querySelector('.allgemeiner-fehler').classList.add('sichtbar');
        } catch (e) {}
    }

    allgemeinenFehlerAusblenden() {
        try {
            this.querySelector('.allgemeiner-fehler').classList.remove('sichtbar');
        } catch (e) {}
    }

    render(htmlContent) {
        try {
            const element = this.querySelector('section');
            element.innerHTML = htmlContent;
        } catch (e) {}
        this.focusOnInvalidElement();
    }

    disableButton() {
        const button = this.getSubmitButton();
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('data-loading', '');
    }

    enableButton() {
        try {
            const button = this.getSubmitButton();
            if (!button.hasAttribute('data-turnstile-pending')) {
                button.removeAttribute('disabled');
            }
            button.removeAttribute('data-loading');
        } catch (e) {}
    }

    addTurnstileSuccessListener() {
        const turnstileContainer = this.querySelector('turnstile-container');
        if (!turnstileContainer) return;
        turnstileContainer.addEventListener('turnstile.success', () => {this.turnstileSuccess();});
    }

    // Anders als beim Login gibt hier auch die Passwort-Ampel den Submit-Button frei (entfernt 'disabled'),
    // sobald das Passwort gueltig ist. Solange Turnstile noch nicht erfolgreich war (data-turnstile-pending),
    // setzt dieser Observer 'disabled' sofort wieder.
    addTurnstileGate() {
        this.turnstileGate?.disconnect();

        const button = this.getSubmitButton();
        if (!button.hasAttribute('data-turnstile-pending')) return;

        this.turnstileGate = new MutationObserver(() => {
            if (button.hasAttribute('data-turnstile-pending') && !button.hasAttribute('disabled')) {
                button.setAttribute('disabled', '');
            }
        });
        this.turnstileGate.observe(button, { attributeFilter: ['disabled'] });
    }

    turnstileSuccess() {
        const button = this.getSubmitButton();
        if (!button.hasAttribute('data-turnstile-pending')) return;

        this.turnstileGate?.disconnect();
        button.removeAttribute('data-turnstile-pending');
        document.querySelector('passwort-ampel')?.pruefeAnzahlAnforderungen();
    }

    getSubmitButton() {
        return this.querySelector('[interaction=form-submit]');
    }

    focusOnInvalidElement() {
        const fehlerElement = this.querySelector('.fehler');
        if (fehlerElement === null) {
            this.scrollIntoView();
        } else {
            fehlerElement.scrollIntoView();
        }
    }

}
customElements.define('nutzer-registrierung', NutzerRegistrierung);